export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-09A.ad45a488.png";